<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlusCircle, faEdit, faUser, faPrint } from '@fortawesome/free-solid-svg-icons'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { Invoice } from '../../modules/posApi/invoices/invoice'
    import { onMount } from 'svelte'
    import type { User } from '../../modules/usersApi/users/user'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import dayjs from 'dayjs'
    import DateSelect from '../_common/date-select.svelte'
    import Helper from '../_common/helper.svelte'
    import Popover from '../_common/popover.svelte'
    import PosForm from './pos-form.svelte'

    let users: User[] = []

    let show = false
    let entities: Invoice[] = []
    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    let dateSelect

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            const filter = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                payment: true,
                status: 'budget',
            }

            // limita a navegação por mais de 7 dias
            if (!window.store.token.permissions.pos.sales.navigate) {
                const diff = dayjs(new Date()).diff(filter.from, 'days')
                if (diff > 7) {
                    dates.from = dayjs(new Date()).add(-7, 'day').toDate()
                    filter.from = dates.from
                    dateSelect.setDate(dates.from, dates.to)
                }
            }
            entities = await window.api.pos.invoices.getAll(filter)
            console.log('entities', entities)
            users = await window.api.users.companies.getCompanyUsers()
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            for (let invoice of entities) {
                invoice.user = users.find((el) => el.userId === invoice?.userId)
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    async function dateChanged(event) {
        dates = event.detail
        await loadEntities()
    }

    function showPerson(personId) {
        window.person('show', personId)
    }

    let showForm = false
    let invoiceId: string = null
    let print: boolean = false
    function editEntity(id, _print = false) {
        print = _print
        invoiceId = id
        showForm = true
    }
    function newEntity() {
        print = false
        invoiceId = null
        showForm = true
    }
    function formChanged() {
        print = false
        loadEntities()
        showForm = false
    }
    function formCanceled() {
        print = false
        showForm = false
    }

    function translateStatus(status) {
        if (status === 'open') return 'Aberto'
        if (status === 'closed') return 'Fechado'
        if (status === 'subsidized') return 'Baixado'
        if (status === 'credit') return 'Crédito'
        if (status === 'budget') return 'Orçamento'
        return 'Parcial'
    }
</script>

{#if showForm}
    <Popover
        title="Orçamento"
        width="1300px"
        height="90vh"
        on:close={() => {
            showForm = false
        }}
    >
        <PosForm {print} budget={true} {invoiceId} on:change={formChanged} on:cancel={formCanceled} />
    </Popover>
{/if}

<Content footer={true}>
    <div class="grid-act">
        <DateSelect bind:this={dateSelect} on:change={dateChanged} />
        <div class="spacer h-mobile" />
        {#if window.store.token.permissions.pos.sales.write}
            <button class="btn btn-secondary h-mobile" on:click={() => window.print()}><Fa icon={faPrint} /></button>
            <button class="btn btn-primary new" on:click={newEntity}><Fa icon={faPlusCircle} /> <span class="h-mobile"> Novo orçamento</span></button>
        {/if}
    </div>
    {#if entities.length > 0}
        <div class="subtitle mt-1 mb-1">Orçamentos emitidos</div>
        <div class="grid-head">
            <div class="row">
                <div class="col-1 h-mobile">Status</div>
                <div class="col-2">Data</div>
                <div class="col">&nbsp;Pessoa</div>
                <div class="col-3 col-md-2 text-end">Valor do orçamento</div>
                <div class="col acts h-print" />
            </div>
        </div>
    {/if}
    <div class="grid-body mb-4">
        {#if entities.length === 0}
            <Helper
                image="/img/automation.png"
                title="Orçamentos"
                text="Emita orçamentos para seus  clientes"
                list={['Emita um orçamento e compartilhe através de um link', 'Converta um orçamento em venda e economize tempo']}
            >
                <button class="h-mobile" on:click={newEntity}>Lançar primeiro orçamento do dia</button>
            </Helper>
        {/if}
        {#if !show}
            {#each entities as invoice}
                <div class="row line liner py-1">
                    <div class="col-1 h-mobile">
                        <div class="badge status_{invoice.status}">
                            {translateStatus(invoice.status)}
                        </div>
                    </div>
                    <div class="col-2 h-full">{dayjs(invoice.createdAt).format('DD/MM/YY')}</div>
                    <div class="col-2 h-mobile">{dayjs(invoice.createdAt).format('DD/MM/YYYY HH:mm')}</div>
                    <div class="col nowrap">&nbsp;{invoice.person?.name}</div>
                    <div class="col-3 col-md-2 text-end">{window.api.utils.utils.toReal(invoice.total)}</div>
                    <div class="col text-md-end h-print acts">
                        {#if window.store.token.permissions.persons.show}
                            <button
                                class="btn btn-secondary btn-sm h-mobile"
                                on:mousedown|stopPropagation
                                on:click|stopPropagation={() => showPerson(invoice.person?.personId)}
                            >
                                <Fa size="sm" icon={faUser} /></button
                            >
                        {/if}
                        <button
                            class="btn btn-secondary btn-sm"
                            on:click={() => {
                                editEntity(invoice.invoiceId, true)
                            }}
                        >
                            <Fa icon={faPrint} /> <span class="h-mobile">Imprimir</span>
                        </button>
                        <button
                            class="btn btn-secondary btn-sm"
                            on:click={() => {
                                editEntity(invoice.invoiceId)
                            }}
                        >
                            <Fa icon={faEdit} /> <span class="h-mobile">Editar</span>
                        </button>
                    </div>
                </div>
            {/each}
        {/if}
    </div>

    <LoadSpinner {show} />
</Content>

<style>
    .resume {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        font-size: 13px;
    }
    .btns {
        text-align: right;
    }

    .acts {
        max-width: 265px;
    }

    @media (max-width: 900px) {
        .grid-act {
            background-color: unset;
            display: flex;
            justify-content: space-around;
        }
        .grid-act .btn {
            max-width: 120px;
            flex-grow: 1;
        }
    }
</style>
